import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { deleteData, getData, patchData, postData } from "src/utils/axios/serverHelper";
import { formatDate } from "src/utils/string/stringUtil";
import { KSK2030_R01DetailDto, KSK2030_R01Dto } from "./Dto_KSK2030_R01";
import { KSK2030_R01Filter } from "./Store_KSK2030_R01";

const baseUrl = `${config.apiUrl}/KSK2030_R01`;

const getParams = (filter: Partial<KSK2030_R01Filter>, listLength?: number) => {
	return {
		compCd: filter.compCd,
		workplaceCd: filter.workplaceCd,
		jobTeam: filter.jobTeam,
		startDate: filter.dateRange?.from ? formatDate(filter.dateRange.from) : undefined,
		endDate: filter.dateRange?.to ? formatDate(filter.dateRange.to) : undefined,
		closeTag: filter.closeTag,
		listLength: listLength || 0
	}
}

export const getKSK2030_R01List = async (option: string, params: Partial<KSK2030_R01Filter>, listLength: number = 0) => {
    const url = `${baseUrl}/${option}`

    return await getData<ResponseDto<KSK2030_R01Dto[]>>(url, { params: getParams(params, listLength) });
}

export const getKSK2030_R01AllCount = async (params: Partial<KSK2030_R01Filter>) => {
    const url = `${baseUrl}/allCount`;
    return await getData<ResponseDto<number>>(url, { params: getParams(params, 0) });
}

export const getKSK2030_R01DetailList = async (productResultNo: string) => {
    const url = `${baseUrl}/detail`

    return await getData<ResponseDto<KSK2030_R01DetailDto[]>>(url, { params: { productResultNo: productResultNo } });
}

export const postKSK2030_R01 = async (data: KSK2030_R01Dto) => {
    const url = `${baseUrl}`;

    return await postData<KSK2030_R01Dto, ResponseDto<KSK2030_R01Dto>>(url, data);
}

export const patchKSK2030_R01 = async (data: KSK2030_R01Dto) => {
    const url = `${baseUrl}`;

    return await patchData<KSK2030_R01Dto, ResponseDto<KSK2030_R01Dto>>(url, data);
}

export const deleteKSK2030_R01 = async (userId: string) => {
    let url = `${baseUrl}/${userId}`;

    return await deleteData<ResponseDto<any>>(url);
}

export const downloadExcel_KSK2030_R01 = async (option: string, params: Partial<KSK2030_R01Filter>, listLength: number = 0) => {
    const url = `${baseUrl}/excel/${option}`

    return await getData<ResponseDto<string>>(url, { params: getParams(params, listLength) });
}